import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { Router } from '@angular/router';
import { BoobleModalService } from 'booble-modal';
import { ContactModal } from '../../modals/contact/contact-modal.component';
import { PrivacyPolicyModal } from '../../modals/privacy-policy/privacy-policy-modal.component';
import { UseTermsModal } from '../../modals/use-terms/use-terms-modal.component';
import { RegisterService } from '../../services/register.service';
import { FooterLayoutComponent } from '../footer-layout/footer-layout.component';

@Component({
  selector: 'app-onboardings-layout',
  templateUrl: './onboardings-layout.component.html',
  styleUrls: ['./onboardings-layout.component.scss'],
})
export class OnboardingsLayoutComponent implements OnInit {
  step: number;
  actualRoute = '';

  constructor(
    private readonly registerService: RegisterService,
    private readonly modalService: BoobleModalService,
    private router: Router
  ) {
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  ngOnInit(): void {
    this.actualRoute = this.router.url;
    this.registerService.getRegisterStep().subscribe({
      next: (stepResult) => {
        this.step = stepResult.data.registerStep.id;
      },
    });
  }

  goToStep(route: string) {
    this.router.navigate([`${route}`]);
  }

  openTermsModal() {
    this.modalService.present(UseTermsModal);
  }

  openPrivacyPolicyModal() {
    this.modalService.present(PrivacyPolicyModal);
  }

  openContactModal() {
    this.modalService.present(ContactModal);
  }
}
